<template>
  <div>
    <el-dialog :visible.sync="visible" title="发送司机通知" width="600px" :close-on-click-modal="false" @closed="clearData">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="司机" prop="driverId">
          <el-select v-model="form.driverId" filterable remote :remote-method="searchDrivers" :loading="driverLoading"
            placeholder="请输入司机编号或姓名搜索" style="width: 100%" clearable>
            <el-option v-for="item in driverOptions" :key="item.id" :label="`${item.no} - ${item.name}`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入通知标题" maxlength="100"></el-input>
        </el-form-item>

        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="form.content" placeholder="请输入通知内容" :rows="6" maxlength="500"
            show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="附件" prop="imgs">
          <multiple-file-upload v-model="form.imgs" :simpleData="true" :limit="3" filePath="/driver_notice"
            uploadTip="仅支持图片上传，最多3张（单张不超过20MB）" :before-upload="beforeImgUpload" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit" :loading="submitting">发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sendSimpleNotice, getDriverInfo, searchDriver } from "@/api";

export default {
  name: "DriverNotice",

  data() {
    return {
      visible: false,
      submitting: false,
      driverLoading: false,
      driverOptions: [],
      form: {
        driverId: null,
        title: "",
        content: "",
        imgs: []
      },
      rules: {
        driverId: [{ required: true, message: "请选择司机", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      },
      callback: null
    };
  },
  methods: {
    show(data) {
      const { driverId, callback } = data || {};
      this.callback = callback;
      this.visible = true;

      // 如果传入了 driverId，则加载该司机信息并选中
      if (driverId) {
        this.form.driverId = driverId;
        this.loadDriverById(driverId);
      } else {
        // 清空表单
        this.form = {
          driverId: null,
          title: "",
          content: "",
          imgs: []
        };
      }
    },

    loadDriverById(driverId) {
      this.driverLoading = true;
      getDriverInfo({ id: driverId })
        .then((res) => {
          this.driverOptions = [res.data];
        })
        .catch(() => {
          this.$message.error("加载司机信息失败");
        })
        .finally(() => {
          this.driverLoading = false;
        });
    },

    searchDrivers(query) {
      if (!query) {
        this.driverOptions = [];
        return;
      }
      this.driverLoading = true;
      searchDriver(query)
        .then((res) => {
          this.driverOptions = res.data || [];
        })
        .catch(() => {
          this.$message.error("搜索司机失败");
        })
        .finally(() => {
          this.driverLoading = false;
        });
    },

    handleCancel() {
      this.visible = false;
    },

    beforeImgUpload(file) {
      const isImage = /^image\/(jpeg|jpg|png|gif|webp|bmp)$/.test((file && file.type) || "");
      if (!isImage) {
        this.$message.warning("仅支持上传图片格式文件");
      }
      return isImage;
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }

        this.submitting = true;
        const params = {
          driverId: this.form.driverId,
          title: this.form.title,
          content: this.form.content,
          imgs: Array.isArray(this.form.imgs) ? this.form.imgs : []
        };

        sendSimpleNotice(params)
          .then((res) => {
            this.$message.success("通知发送成功");
            this.visible = false;
            if (this.callback) {
              this.callback(res.data);
            }
          })
          .catch((err) => {
            this.$message.error(err.message || "通知发送失败");
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },

    clearData() {
      this.$refs.form.resetFields();
      this.form = {
        driverId: null,
        title: "",
        content: "",
        imgs: []
      };
      this.driverOptions = [];
      this.callback = null;
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: right;
}
</style>
